import { SvgFolder, TextButton } from '@loomhq/lens';
import React from 'react';

import { FOLDERS_LOOMS_PAGE } from 'constants/routes';
import { getSlug } from 'utilities/folder';

import styles from './styles.module.less';

const DestinationBreadcrumb = ({ breadcrumbs = [] }) => {
  const lastBreadCrumb = [].concat(breadcrumbs).pop();

  const handleClick = () =>
    (window.location.pathname = lastBreadCrumb?.id
      ? `${FOLDERS_LOOMS_PAGE}/${getSlug(lastBreadCrumb)}`
      : FOLDERS_LOOMS_PAGE);

  return (
    <>
      {breadcrumbs.length > 1 && (
        <TextButton
          size="medium"
          icon={<SvgFolder />}
          offsetSide="left"
          onClick={handleClick}
          className={styles.breadcrumbButton}
        >
          {lastBreadCrumb.name}
        </TextButton>
      )}
    </>
  );
};

export default DestinationBreadcrumb;
